import { addPagesFromContext, addWidgetsFromContext } from "@insite/client-framework/Configuration";
import { setPostStyleGuideTheme } from "@insite/client-framework/ThemeConfiguration";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { InputStyle } from "@insite/mobius/TextField";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";

import { css } from "styled-components";
import BrasselerColors from "@BUSAMedicalMarketing/Utils/Colors";
// For production, include a set of commonly used widgets in the main bundle
// the rest will be split into their own chunks
// Do not do this for the ./Overrides folder
const widgets = IS_PRODUCTION
    ? require.context("./Widgets", true, /(Header|Basic|Common|Footer|SignIn)\/.+?\.tsx$/)
    : require.context("./Widgets", true, /\.tsx$/);
// enable hot module reloading for widgets
const onHotWidgetReplace = addWidgetsFromContext(widgets);
if (module.hot) {
    module.hot.accept(widgets.id.toString(), () => onHotWidgetReplace(require.context("./Widgets", true, /\.tsx$/)));
}

// Load all custom pages so they are included in the bundle and enable hot module reloading for them. Do not do this for the ./Overrides folder
// const pages = require.context("./Pages", true, /\.tsx$/);
// const onHotPageReplace = addPagesFromContext(pages);
// if (module.hot) {
//     module.hot.accept(pages.id.toString(), () => onHotPageReplace(require.context("./Pages", true, /\.tsx$/))); //upgrade/front-end-5.2.2604.644+lts
// }

// Load all handlers so they are included in the bundle.
// const handlers = require.context("./Handlers", true);
// handlers.keys().forEach(key => handlers(key));

// const stylesExtensions = require.context("./StylesExtensions", true);
// stylesExtensions.keys().forEach(key => stylesExtensions(key));

// const store = require.context("./Store", true);
// store.keys().forEach(key => store(key));

// in production, the widget extensions are included in the chunks created for widgets
// if (!IS_PRODUCTION) {
//     // load all widget extensions. They could be loaded individually instead
//     const widgetExtensions = require.context("./WidgetExtensions", true);
//     widgetExtensions.keys().forEach(key => widgetExtensions(key));
// }

setPostStyleGuideTheme({
    breakpoints: {
        keys: ["xs", "sm", "md", "lg", "xl"],
        values: [0, 576, 768, 992, 1200],
        maxWidths: [540, 540, 820, 960, 1440],
    },
    globalStyle: {
        css: css`
            main {
                padding: 0 !important;
                min-height: 300px;
            }

            #react-app main {
                /* background: #e5e5e5 !important; */
            }

            .smart-reward-dashboard-title {
                h1 {
                    font-size: 65px;

                    ${({ theme }) => {
                        return breakpointMediaQueries(
                            theme,
                            [
                                css`
                                    font-size: 24px;
                                `,
                                css`
                                    font-size: 24px;
                                `,
                                null,
                                null,
                                null,
                            ],
                            "max",
                        );
                    }}
                }
            }

            input[type="number"] {
                -moz-appearance: textfield !important;
            }

            main,
            footer {
                position: relative;
            }

            select {
                font-family: "Roboto Condensed";

                > option {
                    font-family: "Roboto Condensed", sans-serif;
                }
            }

            @media print {
                html {
                    [class^="PageLayoutWrapper"] {
                        > span[class^="TypographyStyle"] {
                            display: none;
                        }
                    }
                }

                @page {
                    size: auto;
                    margin: 0mm;
                }
                .hide-for-print,
                header {
                    display: none !important;
                }

                #print-div {
                    display: block !important;
                    margin: 3em;
                }
            }

            #react-app [class^="LoadingOverlayStyle"] {
                > [data-test-selector="loadingOverlaySpinner"][data-loading="true"] {
                    background-color: transparent;
                }
            }
        `,
    },
    lists: {
        defaultProps: {
            css: css`
                list-style: none;
                padding-left: 0;
            `,
        },
    },
    typography: {
        // fontFamilyImportUrl:
        //     "https://fonts.googleapis.com/css2?family=Roboto+Condensed:ital,wght@0,300;0,400;0,700;1,300;1,400;1,700&display=swap",
        body: {
            fontFamily: "Arial, Helvetica, sans-serif",
            size: "16px",
            weight: 400,
        },
        p: {
            size: "16px",
        },
        headerPrimary: {
            fontFamily: "Arial, Helvetica, sans-serif",
            size: "18px",
        },
        headerSecondary: {
            fontFamily: "Arial, Helvetica, sans-serif",
            size: "16px",
        },
        headerTertiary: {
            fontFamily: "Arial, Helvetica, sans-serif",
            size: "16px",
        },
        h1: {
            size: "65px",
            lineHeight: "150%",
            css: css`
                color: ${getColor("secondary")};
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            font-size: 35px !important;
                        `,
                        css`
                            font-size: 35px !important;
                        `,
                        css``,
                        css``,
                        null,
                    ])}
            `,
        },
        h2: {
            size: "47px",
            lineHeight: "110%",
            css: css`
                color: ${getColor("secondary")};
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            font-size: 30px;
                        `,
                        css`
                            font-size: 30px;
                        `,
                        css``,
                        css``,
                        null,
                    ])}
            `,
        },
        h3: {
            size: "28px",
            lineHeight: "110%",
            css: css`
                color: ${getColor("secondary")};
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            font-size: 25px;
                        `,
                        css`
                            font-size: 25px;
                        `,
                        css``,
                        css``,
                        null,
                    ])}
            `,
        },
        h4: {
            size: "20px",
        },
        h5: {
            size: "18px",
        },
        h6: {
            size: "16px",
        },
    },

    button: {
        primary: {
            color: "#0033A0",
            hoverMode: "lighten",
            css: css`
                border-radius: 5px 0;
                padding: 10px 24px;
                &:hover {
                    background: #4c9fdc;
                    border-color: #4c9fdc;
                }
            `,
        },
        secondary: {
            buttonType: "solid",
            color: "#A50031",
            hoverMode: "lighten",
            css: css`
                border-radius: 5px 0;
                padding: 10px 24px;
                &:hover {
                    color: #a50031;
                    background: #fff;
                    border-color: #a50031;
                }
            `,
        },
        tertiary: {
            buttonType: "outline",
            color: "#fff",
            hoverMode: "darken",
            css: css`
                border-radius: 5px 0;
                padding: 10px 24px;
                &:hover {
                    color: #0033a0 !important;
                    background: #fff !important;
                }
            `,
        },
    },
    formField: {
        defaultProps: {
            cssOverrides: {
                inputSelect: css`
                    border-radius: 5px 0;
                    height: 2.7rem;
                    border: 1px solid #aeb7c6;
                    margin-bottom: 0.5rem;
                `,
                formInputWrapper: css`
                    margin-top: 0 !important;
                `,
            },
            backgroundColor: "primary.contrast",
            border: "rectangle",
            labelProps: {
                color: "primary",
                fontFamily: "Roboto Condensed",
                size: "16px",
                transform: "capitalize",
                weight: 700,
                css: css`
                    margin-bottom: 2px;
                `,
            },
            errorProps: {
                size: 14,
                color: "warning",
                css: css``,
            },
        },
    },
    modal: {
        defaultProps: {
            closeButtonIconProps: {
                css: css`
                    color: ${BrasselerColors.blue5} !important;
                    font-weight: 700;
                `,
            },
            closeButtonProps: {
                css: css`
                    svg {
                        stroke-width: 3;
                    }
                `,
            },
            cssOverrides: {
                // BSM:858 fix
                modalContainer: css`
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                null,
                                null,
                                null,
                                css`
                                    transform: translate(-50%, -50%) !important;
                                    top: 50% !important;
                                    left: 50% !important;
                                    height: auto !important;
                                    position: fixed;
                                    width: 90%;
                                    max-width: 500px;
                                `,
                                null,
                            ],
                            "max",
                        )}
                `,
                modalContent: css`
                    padding: 0 2.36em 2.343rem;
                    min-height: auto;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                null,
                                null,
                                css`
                                    padding: 15px 30px;
                                `,
                                null,
                                null,
                            ],
                            "max",
                        )}
                `,
                modalTitle: css`
                    padding: 2.398em 2.36em 0;
                    border: 0;

                    #CloseModalButton {
                        transform: translateY(-10px);
                    }
                `,

                modalBody: css`
                    box-shadow: 0 20px 40px rgba(0, 25, 74, 0.6);
                    border-radius: 10px 0;
                `,
                headlineTypography: css`
                    font-size: 30px;
                    color: ${getColor("primary")};
                    font-weight: 700;
                    margin-bottom: 0;
                `,
            },
        },
    },
    checkbox: {
        defaultProps: {
            color: "#0075FF",
            css: css`
                span[role="checkbox"] {
                    &:focus {
                        border: none;
                        box-shadow: none;
                        outline: 0;
                    }
                }
            `,
        },
    },

    // accordion: {
    //     sectionDefaultProps: {
    //         headerProps: {
    //             css: css`
    //                 button {
    //                     border-radius: 4px;
    //                     background: ${getColor("secondary")};
    //                     border: none;
    //                     margin-bottom: 8px;
    //                     padding: 15px 20px !important;
    //                     > ${TypographyStyle} {
    //                         font-family: "MontserratMedium";
    //                         color: ${getColor("text.accent")};
    //                         font-size: 18px;
    //                         font-weight: 800;

    //                         ${({ theme }: { theme: BaseTheme }) =>
    //                             breakpointMediaQueries(theme, [
    //                                 css`
    //                                     font-size: 14px;
    //                                 `,
    //                                 css`
    //                                     font-size: 14px;
    //                                 `,
    //                                 css``,
    //                                 css``,
    //                                 null,
    //                             ])}
    //                     }
    //                     &:focus {
    //                         border: 0 solid transparent !important;
    //                         padding: 15px 20px !important;
    //                     }
    //                 }
    //             `,
    //         },
    //         panelProps: {
    //             css: css`
    //                 padding: 0.7rem 1.6rem;
    //                 border: none;
    //                 > ${GridWrapper} {
    //                     > ${GridOffset} {
    //                         > ${GridItemStyle} {
    //                             ${RadioStyle} {
    //                                 ${TypographyStyle} {
    //                                     font-size: 14px;
    //                                 }
    //                             }
    //                         }
    //                         > ${GridItemStyle}:last-child {
    //                             > ${TypographyStyle} {
    //                                 font-size: 1rem;
    //                             }
    //                         }
    //                     }
    //                 }
    //             `,
    //         },
    //         titleTypographyProps: {
    //             css: css`
    //                 color: ${getColor("primary")};
    //             `,
    //         },
    //         toggleIconProps: {
    //             css: css`
    //                 color: ${getColor("primary")};
    //             `,
    //         },
    //     },
    // },
    // dataTable: {
    //     defaultProps: {
    //         cssOverrides: {
    //             head: css`
    //                 th {
    //                     background-color: ${getColor("secondary")};
    //                     border-right: 1px solid #e5e5e5;
    //                     border-bottom: none;
    //                     border-radius: 4px;
    //                     button {
    //                         height: 90%;
    //                     }
    //                 }
    //                 th:last-child {
    //                     border-right: none;
    //                 }
    //             `,
    //             body: css`
    //                 tr:nth-child(even) {
    //                     background: #ffffff;
    //                 }
    //             `,
    //             cell: css`
    //                 height: 60px;
    //             `,
    //         },
    //         headerTypographyProps: {
    //             color: "primary",
    //             size: 16,
    //         },
    //         cellTypographyProps: {
    //             size: 16,
    //         },
    //     },
    // },
    // tag: {
    //     defaultProps: {
    //         css: css`
    //             background-color: #f3efeb;
    //             border-radius: 4px;
    //             color: ${getColor("primary")};
    //             ${TypographyStyle} {
    //                 display: flex;
    //                 flex-direction: column;
    //                 justify-content: center;
    //             }
    //             > ${ButtonWrapper} {
    //                 background-color: transparent;
    //             }
    //         `,
    //     },
    // },
    // pagination: {
    //     defaultProps: {
    //         cssOverrides: {
    //             pagination: css`
    //                 background-color: ${getColor("secondary")};
    //                 padding: 5px;
    //                 label {
    //                     font-weight: normal !important;
    //                     color: ${getColor("text.main")} !important;
    //                     font-size: 14px !important;
    //                 }
    //                 select {
    //                     font-size: 14px !important;
    //                     height: 36px;
    //                 }
    //             `,
    //             currentButton: css`
    //                 cursor: default;
    //                 background-color: ${getColor("primary")};
    //                 min-height: 30px;
    //             `,
    //             linkList: css`
    //                 button {
    //                     max-width: max-content !important;
    //                     width: max-content !important;
    //                 }
    //             `,
    //         },
    //     },
    // },
    // lists: {
    //     defaultProps: {
    //         css: css`
    //             margin: 0px;
    //             padding: 0px;
    //         `,
    //     },
    // },
});
